import { render, staticRenderFns } from "./SkupoviTeme.vue?vue&type=template&id=60a67d08&scoped=true&"
import script from "./SkupoviTeme.vue?vue&type=script&lang=js&"
export * from "./SkupoviTeme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a67d08",
  null
  
)

export default component.exports